import { useEffect, useState } from "react";
import { articlePreloader } from "@/features/gebreken/services/article-preloader";
import type { Article } from "@/features/gebreken/types/article";

interface UseArticlePreloaderReturn {
  articles: Article[] | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: Error | null;
  preload: () => Promise<void>;
}

export function useArticlePreloader(): UseArticlePreloaderReturn {
  const [data, setData] = useState(articlePreloader.getData());

  useEffect(() => {
    const unsubscribe = articlePreloader.subscribe(() => {
      setData(articlePreloader.getData());
    });

    return unsubscribe;
  }, []);

  return {
    ...data,
    preload: () => articlePreloader.preload(),
  };
}
